import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

/**
 * Challenges — src/Design/industries/industry-*.html, SECTION 2.
 * Four cards, each its own background photo with a dark gradient overlay
 * (alternating tint, odd/even) and text at the bottom. No icons.
 */
const ChallengeGrid = ({ eyebrow, heading, intro, items = [] }) => {
  if (!items.length) return null

  return (
    <section className="ichallenges ip-block">
      <div className="ichallenges__inner">
        <div className="ichallenges__head">
          <div>
            <p className="ichallenges__eyebrow">{eyebrow}</p>
            <h2 className="ichallenges__heading">{heading}</h2>
          </div>
          {intro && <p className="ichallenges__intro">{intro}</p>}
        </div>

        <div className="ichallenges__tiles">
          {items.map(item => (
            <article className="ichallenges__tile" key={item.heading}>
              {item.image && (
                <GatsbyImage image={item.image} alt="" loading="lazy" className="ichallenges__tile-bg" />
              )}
              <div className="ichallenges__tile-text">
                <h3 className="ichallenges__tile-heading">{item.heading}</h3>
                <p className="ichallenges__tile-detail">{item.detail}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ChallengeGrid
